import React, { useEffect, useState } from "react";
import type { FC } from "react";
import api from "../../api";
import UseOrderBox from "../../component/UseOrderBox";
import "./style.scss";
const UseOrderList: FC = () => {
  const [orderList, setOrderList] = useState<Types.Http.IQueryOrderList[]>([]);

  useEffect(() => {
    queryOrderList();
  }, []);

  const queryOrderList = () => {
    api.order
      .queryOrderList<Types.Http.IQueryOrderList[]>()
      .then((res: any) => {
        if (res.code === 1) {
          setOrderList(res.data.data);
        }
      });
  };

  return (
    <div className="order-list">
      {orderList.length > 0 ? (
        orderList.map((item) => {
          return <UseOrderBox orderInfo={item} key={item.id}></UseOrderBox>;
        })
      ) : (
        <div className="order-no-data">
          <img
            src="http://h5-media.oss-cn-hangzhou.aliyuncs.com/libs/img/no-data.png"
            className="no-data"
          />
          <p>暂无相关数据</p>
        </div>
      )}
    </div>
  );
};

export default UseOrderList;
